import ChecklistThemeSubSectionView, {
  ChecklistThemeSubSectionViewProps,
} from './ChecklistThemeSubSectionView';

export default ChecklistThemeSubSectionView;

export type { ChecklistThemeSubSectionViewProps };
